import axios from '@/axios'
import { isBoolean } from 'util'

const find = id => {
	const path = `routes?id=${id}`
	return axios.get(path)
}

const getAll = ({ field, order }, perPage = 10, pageNr = 1, filter, searchText) => {
	let filterSegment = ''
	let searchSegment = ''

	if (filter) {
		if (isBoolean(filter.value)) filterSegment += `&${filter.by}[exists]=${filter.value}`
		else if (Array.isArray(filter.value))
			filter.value.forEach(value => {
				filterSegment += `&${filter.by}[]=${value}`
			})
		else filterSegment += `&${filter.by}=${filter.value}`
	}

	if (searchText) searchSegment = `&search=${searchText}`

	const path = `routes?order[${field}]=${order}&itemsPerPage=${perPage}&page=${pageNr}${filterSegment}${searchSegment}`
	return axios.get(path)
}

const update = route => {
	const path = `routes/${route.id}`

	const routeToSave = { ...route }
	if (route.orders) delete routeToSave.orders
	if (route.creator) delete routeToSave.creator
	if (route.ordersDistances)
		routeToSave.ordersDistances = JSON.stringify(routeToSave.ordersDistances)

	return axios.put(path, routeToSave)
}

const create = route => {
	const path = `routes`
	if (route.creator) delete route.creator
	return axios.post(path, route)
}

const destroy = route => {
	const path = `routes/${route.id}`
	return axios.delete(path)
}

export default {
	find,
	getAll,
	update,
	create,
	destroy
}
